import * as ko from "knockout";
import entityBase from "entityBase";

export class c_task_sparepart extends entityBase {
  part_id: KnockoutObservable<string>;
  description: KnockoutObservable<string>;
  quantity: KnockoutObservable<string>;

  constructor(item: any) {
    super();
    this.part_id = ko.observable(item.part_id);
    this.description = ko.observable(item.description || item?.part?.internal_descriptn);
    this.quantity = ko.observable(item.quantity);
  }
}
